export default __webpack_public_path__ + "static/media/cielo.bde44515.jpg";